
import RelationToOneField from '@/shared/fields/relation-to-one-field';
import { IssuedDocumentService } from '@/modules/issued-document/issued-document-service';

export class IssuedDocumentIssuerField {
    static relationToOne(name, label, rules, filterParams) {
        return new RelationToOneField(
            name,
            label,
            IssuedDocumentService.getDocumentIssuerList,
            (record) => {
                if (!record) {
                    return '';
                }
                return {
                    value: record.issuer_user_id,
                    text: record.issuer_user_full_name,
                };
            },
            rules,
            filterParams,
        );
    }
}
